import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts';
import { Link, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Pagination, Navigation } from 'swiper';
import Button from '../../../components/Button/Button';
import './MnDashboardStyle.css'
import MnRequest from '../../../components/MnRequest/MnRequest';
import { useDispatch, useSelector } from 'react-redux';
import { clearState, getDashBoardMentor, getMentorCallsActivity, getMentorPerformance, getUpcomingInterviewDetails, mentorData } from '../../../reducer/mentorSlice';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import moment from 'moment/moment';
import ErrorToast from '../../../components/Toast/ErrorToast';
import Skeleton from 'react-loading-skeleton';


const MnDashboard = () => {

    const navigationNextRefds = React.useRef(null);
    const navigationPrevRefds = React.useRef(null);

    const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    const months = [monthNames[moment().subtract(5,"months").month()], monthNames[moment().subtract(4,"months").month()], monthNames[moment().subtract(3,"months").month()], monthNames[moment().subtract(2,"months").month()], monthNames[moment().subtract(1,"months").month()], monthNames[moment().month()]];

    const navigationNextRefNew = React.useRef(null);
    const navigationPrevRefNew = React.useRef(null);

    //states
  const [totalCalls, setTotalCalls] = useState([]);
  const [completedCalls, setCompletedCalls] = useState([]);
  const [cancelledCalls, setCancelledCalls] = useState([]);
  const [rescheduledCalls, setRescheduledCalls] = useState([]);
  const [unattendedCalls, setUnttendedCalls] = useState([]);

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isFetching, isPerformanceFetching, isDashboardFetching, isSuccess, isError, errorMessage, upcomingCalls, dashboardCalls, dashboardPerformance } = useSelector(mentorData);

    const getLastWeekDays = () => {
        var result = [];
        for (var i=1; i<8; i++) {
            var d = new Date();
            d.setDate(d.getDate() - i);
            result.push( moment(d).format("ddd") )
        }
    
        return result;
    };

    useEffect(() => {
        dispatch(getUpcomingInterviewDetails({}));    
        dispatch(getMentorCallsActivity());
        dispatch(getMentorPerformance());
    },[]);

    useEffect(() => {
        if(dashboardCalls?.callsGraph?.length > 0) {
          const days = getLastWeekDays();
          let total = [];
          let completed = [];
          let cancelled = [];
          let rescheduled = [];
          let unattended = [];
          days.forEach((day, index) => {
            dashboardCalls?.callsGraph?.forEach((item) => {
              if(day === moment(item?.date).format("ddd")) {
                total.push(item?.total);
                completed.push(item?.completed);
                cancelled.push(item?.cancelled);
                rescheduled.push(item?.rescheduled);
                unattended.push(item?.noshow);
              }
            });
            if(total?.length <= index) total.push(0)
            if(completed?.length <= index) completed.push(0)
            if(cancelled?.length <= index) cancelled.push(0)
            if(rescheduled?.length <= index) rescheduled.push(0)
            if(unattended?.length <= index) unattended.push(0)
          });
          setTotalCalls(total);
          setCompletedCalls(completed);
          setCancelledCalls(cancelled);
          setRescheduledCalls(rescheduled);
          setUnttendedCalls(unattended);
        }
      },[dashboardCalls])

    useEffect(() => {
        if(isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    },[isError]);

    const options2 = {
        chart: {
          type: 'bar',
          height: 250,
          stacked: false // Set stacked to false to allow grouping
        },
        fill: {
          colors: ["#0E77D3"]
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '25%', // Adjust the width of the bars
            grouped: true, // Set grouped to true to group the bars
            borderRadius: "4",
          }
        },
        series: [
          {
            name: '',
            data: totalCalls
          }
        ],
        xaxis: {
          categories: getLastWeekDays()
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          marker: false,
          x: {
            show: false
          },
          y: {
            formatter: function (value, { seriesIndex, dataPointIndex }) {
              if (seriesIndex === 0) {
                const cancelled = cancelledCalls[dataPointIndex];
                const completed = completedCalls[dataPointIndex];
                const unattended = unattendedCalls[dataPointIndex];
                const rescheduled = rescheduledCalls[dataPointIndex];
      
                return `
                  <div class="flexDiv">
                      <div class="custom-tooltip-item tooltipHeading">Total Calls: <span class="dashboardValue">${value}</span></div>
                    
                      <div class="flexColumn">
                        <div class="dataDiv">
                          <div class="custom-tooltip-item ">Cancelled: ${cancelled}</div>
                          <div class="custom-tooltip-item ">Completed: ${completed}</div>
                        </div>
                        <div class="dataDiv">
                          <div class="custom-tooltip-item ">No Show: ${unattended}</div>
                          <div class="custom-tooltip-item ">Rescheduled: ${rescheduled}</div>
                        </div>
                      </div>
      
                  </div>
                `;
              }
            }
          },
          enabled: true,
          style: {
            fontSize: '12px',
            fontFamily: undefined
          }
        }
      };

    var options3 = {
        chart: {
            id: "basic-bar"
        },
        xaxis: {
            categories: ["Total calls"],
            labels: {
                show: false,
            }
        },
        yaxis: {
            labels: {
                show: false,
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
                colors: ['#000']
              },
              formatter: function (val) {
                if(val) return val + '%';
              },
        },
        fill: {
            colors: ["#7757F4", "#7BC896", "#0E77D3", "#EF5350"]
        },
        tooltip: {
            enabled: true,
            style: {
                color: ["#fff"]
            },
            y: {
                formatter: function (val) {
                    if(val) return val + '%';
                  }
            },
            marker: false
        },
        legend: {
            show: false
        },
        plotOptions: {
            bar: {
                borderRadius: 6,
                borderRadiusApplication: 'end',
                columnWidth: '200%',
                distributed: true,
                dataLabels: {
                    position: "top"
                }
            }
        },
        series: [
            {
                name: "Completed",
                data: [null, (dashboardPerformance?.length > 0 ? ((dashboardPerformance[0]?.completed / dashboardPerformance[0]?.total) * 100 ).toFixed(0) : 0)]
            },
            {
                name: "Rescheduled",
                data: [null, null, (dashboardPerformance?.length > 0 ? ((dashboardPerformance[0]?.rescheduled / dashboardPerformance[0]?.total) * 100 ).toFixed(0) : 0)]
            },
            {
                name: "Cancelled",
                data: [null, null, null, (dashboardPerformance?.length > 0 ? ((dashboardPerformance[0]?.cancelled / dashboardPerformance[0]?.total) * 100 ).toFixed(0) : 0)]
            },
            {
                name: "No Show",
                data: [null, null, null, null, (dashboardPerformance?.length > 0 ? ((dashboardPerformance[0]?.noshow / dashboardPerformance[0]?.total) * 100 ).toFixed(0) : 0), null]
            },
        ]
    };

    return (
        <>
        {/* {isFetching && <PageLoader />} */}
        <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
        <div className="AdDashboardMaindivwrap MnDsmnprofile">

            <div className="AdCardMaindivWrap">

              <div className='MncardDstopmain'>
              <div className="AdcardDatacontainer Wrapperforblock cardbordercolor">
                    <div className="mnmtcountgraph flex gap-6">
                        <h3 className='chartheading mb6'>{isDashboardFetching ? <Skeleton width={"50px"} /> : dashboardCalls?.totalCalls ?? 0}</h3>
                        {/* <span className='mtsgrapg bggreen'><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.03457 5.15875C8.93957 5.15875 8.84457 5.12375 8.76957 5.04875L5.99957 2.27875L3.22957 5.04875C3.08457 5.19375 2.84457 5.19375 2.69957 5.04875C2.55457 4.90375 2.55457 4.66375 2.69957 4.51875L5.73457 1.48375C5.87957 1.33875 6.11957 1.33875 6.26457 1.48375L9.29957 4.51875C9.44457 4.66375 9.44457 4.90375 9.29957 5.04875C9.22957 5.12375 9.12957 5.15875 9.03457 5.15875Z" fill="#7BC896" />
                            <path d="M6 10.6259C5.795 10.6259 5.625 10.4559 5.625 10.2509V1.83594C5.625 1.63094 5.795 1.46094 6 1.46094C6.205 1.46094 6.375 1.63094 6.375 1.83594V10.2509C6.375 10.4559 6.205 10.6259 6 10.6259Z" fill="#7BC896" />
                        </svg>11%</span> */}
                    </div>
                    <p className='text2'>{isDashboardFetching ? <Skeleton width={"200px"} /> : 'Total number of completed calls'}</p>

                </div>

                <div className="AdcardDatacontainer Wrapperforblock cardbordercolor">
                    <div className="mnmtcountgraph flex gap-6">
                        <h3 className='chartheading mb6'>{isDashboardFetching ? <Skeleton width={"50px"} /> : dashboardCalls?.callDuration ? (dashboardCalls?.callDuration / 3600).toFixed(1) ?? 0 : 0}</h3>
                        
                    </div>
                    <p className='text2'>{isDashboardFetching ? <Skeleton width={"200px"} /> : 'Total number of hours'}</p>

                </div>

              </div>
                <div className="AdCardSliderWrapper Wrapperforblock cardbordercolor">
                    <div className='AdDsCardheading flex-between'>
                        <div className="flex DsMentorheading">
                            <h3 className='DsCradtext'>Upcoming Calls</h3>
                            <span className='textBlue viewallButton text2' onClick={() => navigate("/mentor/call-records")}>View all</span>
                        </div>
                        <div className="arrowcardsDsAd flex">
                            <img src="assets/img/arrowleft.png" alt="" className='pointer eqiconarrow' ref={navigationNextRefds} />
                            <img src="assets/img/arrowright.png" alt="" className='pointer eqiconarrow' ref={navigationPrevRefds} />
                        </div>
                    </div>

                    <Swiper
                        slidesPerView={1}
                        modules={[Navigation]}
                        loop={false}
                        spaceBetween={20}


                        onSwiper={(swiper) => {
                            // Delay execution for the refs to be defined
                            setTimeout(() => {
                                // Override prevEl & nextEl now that refs are defined
                                swiper.params.navigation.prevEl = navigationPrevRefds.current
                                swiper.params.navigation.nextEl = navigationNextRefds.current

                                // Re-init navigation
                                swiper.navigation.destroy()
                                swiper.navigation.init()
                                swiper.navigation.update()
                            })
                        }}
                        navigation={{
                            // Both prevEl & nextEl are null at render so this does not work
                            prevEl: navigationPrevRefds.current,
                            nextEl: navigationNextRefds.current,
                        }}
                        onBeforeInit={(swiper) => {
                            swiper.navigation.nextEl = navigationNextRefds.current;
                            swiper.navigation.prevEl = navigationPrevRefds.current;
                        }}

                        className="mySwiper">

                        <div className='AdswiperWrappermain'>
                            {isFetching ?
                            <MnRequest imgLoading={<Skeleton width={"50px"} height={"50px"} circle />} name={<Skeleton width={"100px"} />} type={<Skeleton width={"200px"} />} dataclass="fistdicfull" 
                             compdata={<Skeleton width={"500px"} />} expdata={<Skeleton width={"100px"} />}  domdata={<Skeleton width={"100px"} />}
                        />
                        :
                         upcomingCalls?.calls?.length > 0 ? upcomingCalls?.calls?.slice(0,9)?.map((item, index) => (
                                <SwiperSlide >
                                    <MnRequest joinbtn={item?.mentorMeetingLink} name={item?.mentee?.firstName ? `${item?.mentee?.firstName} ${item?.mentee?.lastName}` : "---"} type={item?.mentee?.profession?.title? item?.mentee?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"} dataclass="fistdicfull" 
                                        company="Agenda:" compdata={item?.agenda ? item?.agenda : "---"} exp=" Date:" expdata={item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("DD MMM YYYY") : "---"} dom="Time:" domdata={item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("h:mm a") : "---"}
                                    />
                                </SwiperSlide>
                            )) : "No Upcoming calls"}
                        </div>
                    </Swiper>

                </div>

            </div>

            <div className="AdDashBoardMid">

                <div className="AdCardMaindivWrap MndsCardSliderwrap">

                    <div className="MnDashcontainer1 Wrapperforblock">
                        <div className="mnmtcountgraph">
                            <div className="mainTexts">
                                <h2 className="smallHeading heading-2">{isDashboardFetching ? <Skeleton width={"100px"} /> : 'Call Activity'}</h2>
                                <p className="smallText text2">{isDashboardFetching ? <Skeleton width={"110px"} /> : 'Count of calls'}</p>
                            </div>
                        </div>
                        <div className='flex-between Mncountgraphdata'>
                            <div>
                                <div className='flex gap-10'>
                                    <h3 className='chartheading mb6'>{isDashboardFetching ? <Skeleton width={"50px"} /> : dashboardCalls?.totalCallsWeekly ?? 0}</h3>
                                    {/* <span className='mtsgrapg bggreen'><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.03457 5.15875C8.93957 5.15875 8.84457 5.12375 8.76957 5.04875L5.99957 2.27875L3.22957 5.04875C3.08457 5.19375 2.84457 5.19375 2.69957 5.04875C2.55457 4.90375 2.55457 4.66375 2.69957 4.51875L5.73457 1.48375C5.87957 1.33875 6.11957 1.33875 6.26457 1.48375L9.29957 4.51875C9.44457 4.66375 9.44457 4.90375 9.29957 5.04875C9.22957 5.12375 9.12957 5.15875 9.03457 5.15875Z" fill="#7BC896" />
                                        <path d="M6 10.6259C5.795 10.6259 5.625 10.4559 5.625 10.2509V1.83594C5.625 1.63094 5.795 1.46094 6 1.46094C6.205 1.46094 6.375 1.63094 6.375 1.83594V10.2509C6.375 10.4559 6.205 10.6259 6 10.6259Z" fill="#7BC896" />
                                    </svg>7% from last month</span> */}
                                </div>
                                {/* <p className='text2'>Count of calls</p> */}
                            </div>

                            {/* <div className="Multibtntabwrap flex gap-10">
                                <div className="btnweek active">Week</div>
                                <div className="btnweek">Month</div>
                                <div className="btnweek">Year</div>
                            </div> */}

                        </div>
                        <div>
                        {isDashboardFetching ? 
            <div>
            {[...Array(5)].map((_, index) => (
              <Skeleton key={index} height={30} style={{ marginBottom: '10px' }} />
            ))}
          </div>
            :
                            <ReactApexChart className={'mt-30'}
                                options={options2}
                                series={options2.series}
                                type="area"
                                width="100%"
                                height="290px"
                            />}
                        </div>
                    </div>

                    <div className="MnDashcontainer2 Wrapperforblock">
                        <div className="flex-between gap-6">
                            <div className="mainTexts">
                                <h2 className="smallHeading heading-2">Performance <span className='smallText text2'>(Current month)</span></h2>
                                <p className="smallText text2">{dashboardPerformance?.[0]?.total ?? 0} Total Calls </p>
                            </div>
                            {/* <label htmlFor="date" className='Cudatedesign'>
                                <input type="date" id='date' />
                            </label> */}
                        </div>

                        <div >
                            {isPerformanceFetching ? 
            <div>
            {[...Array(5)].map((_, index) => (
              <Skeleton key={index} height={50} style={{ marginBottom: '10px' }} />
            ))}
          </div>
            :<ReactApexChart className={'mt-30'}
                                options={options3}
                                series={options3.series}
                                type="bar"
                                width="100%"
                                height="290px"
                            />}

                            <div className="AdDataGraphwarp AdDataGraphwarp2 ">
                                <div className="dataAdstatana w-100">
                                    <div className='circleround' style={{background: "#7BC896"}}></div>
                                    <p className='text2'> Completed</p>
                                </div>

                                <div className="dataAdstatana w-100">
                                    <div className='circleround' style={{background: "#0E77D3"}}></div>
                                    <p className='text2'> Rescheduled</p>
                                </div>

                                <div className="dataAdstatana w-100">
                                    <div className='circleround' style={{background: "#EF5350"}}></div>
                                    <p className='text2'>Cancelled </p>
                                </div>

                                <div className="dataAdstatana w-100">
                                    <div className='circleround' style={{background: "#7757F4"}}></div>
                                    <p className='text2'> No show</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
        </>
    )
}

export default MnDashboard